<template>
    <div style="width: 100%;color: #fff;font-size: 2.4rem;padding: 2rem 0">
        <div style="width: 100%;display: flex;align-items: center;padding: 1rem 0 2rem 0">
            <span style="color: #f30">*</span>
            {{label}}
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
	name: "form-item",
    props:{
		label:{
            type:String,
            default:''
        }
    }
}
</script>

<style scoped>

</style>
